import MenuItem from "@material-ui/core/MenuItem";
import { FormikProps } from "formik";
import React from "react";
import CustomDropdown from "../../components/Input/CustomDropdown";

interface RequestTypeSelectProps<T> {
  fieldName: keyof T;
  formikProps: FormikProps<T>;
  helperText: string;
  label: string;
}

function RequestTypeSelect<T>({ fieldName, formikProps, helperText, label }: RequestTypeSelectProps<T>) {
  const { errors, handleChange, touched, values } = formikProps;

  return (
    <CustomDropdown
      displayEmpty
      error={!!(errors[fieldName] && touched[fieldName])}
      helperText={helperText}
      id={String(fieldName)}
      labelText={label}
      name={String(fieldName)}
      onChange={handleChange}
      value={values[fieldName] || ""}
    >
      <MenuItem value="DEFAULT">CSC</MenuItem>
      <MenuItem value="APPLICATION_PROCESS">AProE</MenuItem>
      <MenuItem value="">
        <em>Both</em>
      </MenuItem>
    </CustomDropdown>
  );
}

export default RequestTypeSelect;
